import $ from 'jquery';

$(document).on('click', '[data-behavior-remove-element]', function handleClick(e) {
  e.preventDefault();
  $($(this).data('behavior-remove-element')).remove();
});
